export enum AnalyticsReportStatus {
  Preparing = "preparing",
  Ready = "ready",
  Failed = "failed",
}
